export const DINECASH_EARNINGS_NUDGE_TEST_IDS = {
    CONTAINER: "dinecash-earnings-nudge",
};

export const DINE_CASH_POOLING_TEST_IDS = {
    // ── DineCashPoolingPage (pooling screen) ─────────────────────────────────
    CONTAINER: "dine-cash-pooling-container",
    BACK_BUTTON: "dine-cash-pooling-back-btn",
    LOTTIE: "dine-cash-pooling-lottie",
    TITLE: "dine-cash-pooling-title",
    QR_CARD: "dine-cash-pooling-qr-card",
    QR_IMAGE: "dine-cash-pooling-qr-image",
    WHATSAPP_SHARE_BUTTON: "dine-cash-pooling-whatsapp-btn",
    BULLET_LIST: "dine-cash-pooling-bullet-list",
    BULLET_ITEM: "dine-cash-pooling-bullet-item",
    DONE_BUTTON: "dine-cash-pooling-done-btn",
    SENDER_POPUP: "dine-cash-pooling-sender-popup",
    // ── DineCashPoolingWidget (cart page widget) ─────────────────────────────
    WIDGET_CONTAINER: "dine-cash-pooling-widget",
    WIDGET_TITLE: "dine-cash-pooling-widget-title",
    WIDGET_SUBTITLE: "dine-cash-pooling-widget-subtitle",
    WIDGET_TAG: "dine-cash-pooling-widget-tag",
    WIDGET_TOOLTIP_TEXT: "dine-cash-pooling-widget-tooltip-text",
    WIDGET_POOLED_AMOUNT: "dine-cash-pooling-widget-pooled-amount",
};

export const REWARDS_WIDGET_TEST_IDS = {
    CONTAINER: "rewards-widget-container",
    TITLE: "rewards-widget-title",
    SUBTITLE: "rewards-widget-subtitle",
    EARNED_REWARDS_TITLE: "rewards-widget-earned-title",
    EARNED_REWARDS_AMOUNT: "rewards-widget-earned-amount",
    REDEEMABLE_REWARDS_AMOUNT: "rewards-widget-redeemable-amount",
    TOGGLE_SWITCH: "rewards-widget-toggle-switch",
    EXTRA_INFO_ICON: "rewards-widget-extra-info-icon",
    EXTRA_INFO_TEXT: "rewards-widget-extra-info",
    BOOSTER_TITLE: "rewards-widget-booster-title",
    BOOSTER_SUBTITLE: "rewards-widget-booster-subtitle",
    BOOSTER_CONTAINER: "rewards-widget-booster-container",
    LOGO: "rewards-widget-logo",
    ARROW_ICON: "rewards-widget-arrow-icon",
    BOTTOM_NUDGE_CALLOUT: "rewards-widget-bottom-nudge-callout",
};
